/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Global cart
let cart = window.theme.cart;

// Return Cart state before adding new product to the cart
var cartFull = document.getElementById("cart-full");
var cartEmpty = document.getElementById("cart-empty");
var customAmount = document.getElementById("cart_amount");
async function returnCart () {
  let obj;

  const res = await fetch("/cart.json");

  obj = await res.json().then(token => {return token});
  return await obj;
} 

// Function to get the cart and update the global object
function returnCartEvent() {
  returnCart().then(token => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        cart: token
      }
    }));
  
    if (token.item_count > 0 ){
      cartEmpty.style.display = "none";
      cartFull.innerHTML = '<img width= "30px;" height= "30px;" src="https://cdn.shopify.com/s/files/1/2820/8180/files/cart_full_1.png?v=1667825303">'
    } else {
      cartEmpty.style.display = "block";
      cartFull.innerHTML = ''    
    }
  });
}

// First call to the function to retrieve the cart
returnCartEvent()

// You need to call the function to get the cart each time you update the cart, not just once 
document.addEventListener('theme:loading:end', (event) => {
  // Same thing you had but executing it each time the cart changes
  returnCartEvent()
});

// slick slider
$(document).ready(function() {
  $('.responsive').slick({
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    variableWidth: true,
    draggable: true,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/2820/8180/files/Active_Arrow_left.png?v=1679320414'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/2820/8180/files/Bild_2022-11-16_102743998.png?v=1668590873'>",
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  });

  $('.single-item').slick({
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: true,
    slidesToShow: 1,
    prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/2820/8180/files/Active_Arrow_left.png?v=1679320414'>",
    nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/2820/8180/files/Bild_2022-11-16_102743998.png?v=1668590873'>",
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          arrows: false,
          dots: true,
        }
      },
    ]
  });
});


/**
 * FEATURED COLLECTION WITH COLOR SWATCHES SECTION
 */
const alternateImageInputs = document.querySelectorAll(".ProductItem__Image--alternate__Input");
const colorSwatchLabels = document.querySelectorAll(".ProductItem__Image--alternate__Label");

colorSwatchLabels.forEach((element, index) => {
  element.addEventListener('click', () => {
    alternateImageInputs[index].checked = "checked";
  })
})


/**
 * PRODUCT TABS SECTION
 */
const tabButtons = document.querySelectorAll('.ProductTabs__Tab--btn');
const tabRadios = document.querySelectorAll('.ProductTab--radio');

let currentTab = 1;

tabRadios.forEach(e => {
  e.addEventListener('input', () => {
    currentTab = e.value;
    
    updateCurrentTab(currentTab)
  })
});

function updateCurrentTab(index) {
  tabButtons.forEach(e => {
    let buttonIndex = e.getAttribute('data-value')
    if(buttonIndex === index) {
      e.classList.add('active');
    } else {
      e.classList.remove('active');
    }
  })
}

/**
 * UPSELL SNIPPET
 */
// (function initUpsell() {
//   const upsellCheckbox = document.querySelector(".UpsellItem__Input[type='checkbox']");

//   if (upsellCheckbox) {
//     const addToCartButton = document.querySelector('.ProductForm__AddToCart');
//     let currentMasterVariantPrice;
//     let currentMasterQuantity = 1;

//     // We call the updateATC function when variant changes
//     document.addEventListener('variant:changed', function(event) {
//       currentMasterVariantPrice = event.detail.variant.price;

//       updateATC()
//     });

//     // When we check or uncheck any of the upsell products
//     $(".UpsellItem__Input").on('change', () => {
//       updateATC();
//     })

//     // When we update the quantity of the upsell products
//     $(".UpsellForm__Quantity").on('change', () => {
//       updateATC();
//     })

//     // And when we update the quantity of the main product
//     $(".QuantitySelector__CurrentQuantity").on('change', () => {
//       currentMasterQuantity = $(".QuantitySelector__CurrentQuantity").val();

//       updateATC()
//     })

//     // If there's an upsell product selected when the ATC button is pressed, adds the product to the cart
//     addToCartButton.addEventListener('click', () => {
//       upsellAddToCartFlow();
//     })

//     // Initial declarations and calls to functions to determine variant id 
//     function filterVariants(upsell_product) {
//       let productOptions = document.querySelectorAll(".UpsellForm__Select--" + upsell_product.id);
//       let productVariants = upsell_product.variants;
//       let availableVariants = productVariants.filter(variant => variant.available === true);
//       let variantTitle = getVariantTitle(productOptions);
//       let variantId = isVariantAvailable(availableVariants, variantTitle);

//       if(variantId) {
//         return variantId;
//       } else {
//         return false;
//       }
//     }

//     // Builds and returns the variant title to use as handle
//     function getVariantTitle(options) {
//       let variantTitle = "";

//       options.forEach((option, index) => {
//         if(option.value && index === 0) {
//           variantTitle = option.value
//         } else if (option.value) {
//           variantTitle = variantTitle + " / " + option.value 
//         }
//       })

//       return variantTitle;
//     }

//     // Checks if the variable exists in the array of available variants
//     function isVariantAvailable(variantList, variantTitle) {
      
//       let variant = null;

//       variantList.forEach(variantItem => {
//         if(variantItem.title === variantTitle && variantItem.available) {
//           variant = variantItem;
//         }
//       });

//       return variant;
//     }

//     // If selected variant is unavailable
//     function variantIsUnavailable(productId) {
//       const upsellProduct = document.querySelector("#UpsellItem__Input--" + productId);
//       const variantPrice = document.querySelector(".Upsell__Item--price--" + productId);

//       variantPrice.innerText = "Unavailable";

//       updateATC()
//     }

//     // If selected variant is available
//     function variantIsAvailable(productId) {
//       const upsellProduct = JSON.parse(document.querySelector("#UpsellItem__Input--" + productId).value);    
//       const variantPrice = document.querySelector(".Upsell__Item--price--" + productId);
//       const productVariant = filterVariants(upsellProduct);

//       variantPrice.innerText = (productVariant.price / 100).toFixed(2);

//       updateATC()
//     }

//     // Disables the add to cart button if any of the checked products is unavailable on the selected variant
//     function updateATC() {
//       const upsellProductInputs = document.querySelectorAll(".UpsellItem__Input");
//       let buttonDisabled = false;

//       // Loop through the inputs
//       upsellProductInputs.forEach(input => {
//         if(input.checked) {
//           let upsellProduct = JSON.parse(input.value);
//           let upsellVariant = filterVariants(upsellProduct);

//           if(!upsellVariant.available) {
//             buttonDisabled = true;
//           }
//         }
//       })

//       addToCartButton.disabled = buttonDisabled;

//       updateButtonText();
//     }

//     // Updates the ATC button text with the updated price and enables/disables it
//     function updateButtonText() {
//       const upsellProductInputs = document.querySelectorAll(".UpsellItem__Input");
//       let currentPrice = currentMasterVariantPrice * currentMasterQuantity;

//       upsellProductInputs.forEach(input => {
//         if(input.checked) {
//           let upsellProduct = JSON.parse(input.value);
//           let upsellVariant = filterVariants(upsellProduct);
//           let upsellProductQuantity = parseInt(document.querySelector(".UpsellForm__Quantity--" + upsellProduct.id).value);

//           if(upsellVariant.available) {
//             currentPrice += (upsellVariant.price * upsellProductQuantity);
//           }
//         }
//       })

//       if(addToCartButton.disabled) {
//         addToCartButton.innerHTML = window.languages.productFormUnavailable;
//         addToCartButton.setAttribute('disabled', 'disabled');
//         addToCartButton.classList.add('Button--secondary');
//         addToCartButton.removeAttribute('data-action');
//       } else {
//         addToCartButton.removeAttribute('disabled');
//         addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
//         addToCartButton.setAttribute('data-action', 'add-to-cart');
//       }
//     }

//     // Adds the given product to the cart and refreshes the cart
//     const addProductToCart = (products) => {
//       let data = {items: products}

//       setTimeout(function() {
//         fetch(window.Shopify.routes.root + 'cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify(data)
//         })
//         .then(response => {
//           //Refresh cart
//           if(response) {
//             setTimeout(function() {
//               jQuery.getJSON('/cart.js', function(cart) {
                
//                 document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//                   bubbles: true
//                 }));

//               });
//             }, 400); 

//             return response.json();
//           }
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//           return;
//         });
//       }, 400)
//     }

//     function upsellAddToCartFlow() {
//       // Get all upsell product inputs
//       const upsellProductInputs = document.querySelectorAll(".UpsellItem__Input");

//       let upsellProducts = [];

//       // Loop through the inputs
//       upsellProductInputs.forEach(input => {
//         // If the input is checked and the variant available, push the product and the quantity to upsellProductData.items
//         if(input.checked) {
//           let upsellProduct = JSON.parse(input.value);
//           let upsellProductQuantity = parseInt(document.querySelector(".UpsellForm__Quantity--" + upsellProduct.id).value);
//           let upsellVariant = filterVariants(upsellProduct);
          
//           if(upsellVariant) {
//             let productObj = { id: upsellVariant.id, quantity: upsellProductQuantity };

//             upsellProducts.push(productObj);
//           }     
//         }
//       })

//       // If upsellProductData.items contains one or more products, run the add to cart function with the variable as data
//       if(upsellProducts.length) {
//         addProductToCart(upsellProducts);
//       }
//     }
//   }
// })()
/**
* UPSELL SNIPPET END
*/


/* Yotpo Reviews */
let left_sum = 0;

setTimeout(function(){ $( ".y-slider-container" ).css( "left", "0");}, "1000")

setTimeout(function(){ 
  $( ".yotpo-icon-right-arrow-thin" ).click(function() {
    if (left_sum > -3410) {
      left_sum = (left_sum - 310);
      $( ".y-slider-container" ).css( "left", left_sum + "px" );
    }
    if (left_sum < 0 ) {
      $( ".yotpo-icon-left-arrow-thin" ).css( {"color":"black","border-color": "black", "pointer-events": "all",});
    }
    else {
      $( ".y-slider-container" ).css( "left", -3410 + "px" );

    }
  })
}, "1000")

setTimeout(function(){ 
  $( ".yotpo-icon-left-arrow-thin" ).click(function() {
    if (left_sum < 0 ) {
      left_sum = (left_sum + 310);
      $( ".y-slider-container" ).css( "left", left_sum + "px" );
      $( ".yotpo-icon-right-arrow-thin" ).css( {"color":"black","border-color": "black","pointer-events": "all",});
    }
    
    else {
      $( ".y-slider-container" ).css( "left", 0 + "px" );
    }
  })
}, "1000")


setTimeout(function(){  
  if (left_sum === 0) {
    $( ".yotpo-icon-left-arrow-thin" ).css( {"color":"#AAA9A8","border-color": "#AAA9A8", "pointer-events": "none",});
  }
}, "1000")


setTimeout(function(){ 
  $( ".yotpo-icon-left-arrow-thin" ).click(function() {
    if (left_sum >= -310 ) {
      $( ".yotpo-icon-left-arrow-thin" ).css( {"color":"#AAA9A8","border-color": "#AAA9A8","pointer-events": "none"});
    }
  })
}, "1000")


setTimeout(function(){ 
  $( ".yotpo-icon-right-arrow-thin" ).click(function() {
    if (left_sum <= -3410) {
      $( ".yotpo-icon-right-arrow-thin" ).css( {"color":"#AAA9A8","border-color": "#AAA9A8", "pointer-events": "none"});
    }
  })
}, "1000")


/* Product page quantity selector */
$(".QuantityValue--custom").on('click', function() {
  $(".QuantityValue--custom").each(function() {
    $(this).removeClass("is-selected");
  })

  $(this).addClass("is-selected");
  
  $(".CurrentQuantity").text($(this).data("value"));
  $(".QuantityInput--custom").val($(this).data("value"));
});


(function() {
  // Product customizer
  const addToCartButton = document.querySelector('.ProductForm__AddToCart');
  const customizerSwitch = document.querySelector('#customizer-switch');
  const customizerTextInputs = document.querySelectorAll(".EmbroideryTab__InputGroup--text input");
  const uniqueIdInput = document.getElementById("unique-item-id");
  const uidInput = document.getElementById("unique-item-id");
  
  if(window.location.href.includes("/product") && uidInput) {
    // Assign random int to the unique id input
    function uidGen() {
      uidInput.value = Math.floor(Math.random() * 999999)
    }
    
    uidGen()
    
    // When there's any input on the text fields, it checks wether they're empty or not
    $(".EmbroideryTab__InputGroup--text input").on('input change', () => {
      inputContentCheck();
    })
    
    // Check if any of the fields has input 
    function inputContentCheck() {
      let input = false;
    
      for(let i = 0; i < customizerTextInputs.length; i++) {
        if(customizerTextInputs[i].value) {
          customizerSwitch.checked = true;
          input = true;
        }
    
        let inputGroup = document.querySelectorAll(`[data-input-group="${i}"]`)
    
        checkInputGroup(inputGroup)
      }
    
      if(!input) {
        uniqueIdInput.setAttribute("disabled", "");
        customizerSwitch.checked = false;
      } else {
        uniqueIdInput.removeAttribute("disabled", "");
      }
    }
    
    // If the related text field is empty, the other inputs are disabled
    function checkInputGroup(inputGroup) {
      let textInput = Array.from(inputGroup).find(input => input.type === 'text');
    
      if(!textInput.value) {
        inputGroup.forEach(input => {
          if(input.type === 'radio') {
            input.setAttribute("disabled", "");
          }
        })
      } else {
        inputGroup.forEach(input => {
          input.removeAttribute("disabled");
        })
      }
    }
    
    // When button is clicked, the fee product is added if the checkbox is checked
    addToCartButton?.addEventListener('click', () => {
      let key = document.getElementById("unique-item-id").value;
      let products = [{id: 44501859369228, properties: {'Item key': key}}]
    
      if(customizerSwitch.checked) {
        addProductToCart(products)
    
        setTimeout(function() {
          uidGen()
        }, 1000)
      }
    })
    
    // Check cart when it changes
    document.addEventListener('cart:update', function(event) {
      let currentQuantity = cart.item_count;
    
      cart = event.detail.cart;
    
      if(cart.item_count < currentQuantity) {
        cartCheck(cart)
      }
    });
    
    function cartCheck(cart) {
      let feeItems = cart.items.filter(item => item.properties["Item key"]);
      let regularItems = cart.items.filter(item => item.properties["Unique Item ID"]);
      let itemsToDelete = [];
    
      feeItems.forEach(item => {
        let feeId = item.properties["Item key"];
        let hasMatch = false;
    
        regularItems.forEach(item => {
          if(item.properties["Unique Item ID"] === feeId) {
            hasMatch = true;
            
            return;
          }
        })
    
        if(!hasMatch) {
          itemsToDelete.push(item)
        }
      })
    
      regularItems.forEach(item => {
        let itemId = item.properties["Unique Item ID"];
        let hasMatch = false;
    
        feeItems.forEach(item => {
          if(item.properties["Item key"] === itemId) {
            hasMatch = true;
            
            return;
          }
        })
    
        if(!hasMatch) {
          itemsToDelete.push(item)
        }
      })
    
      itemsToDelete.forEach(item => {
        removeItemFromCart(item)
      })
    }
    
    // Run funcions when initializing to set everything up
    (function initCustomizer() {
      if(window.location.href.includes("/product")) {
        inputContentCheck()
      }
    
      cartCheck(cart);
    })();
    
    // Add to cart function
    const addProductToCart = (products) => {
      let data = {items: products}
    
      setTimeout(function() {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          //Refresh cart
          if(response) {
            setTimeout(function() {
              jQuery.getJSON('/cart.js', function(cart) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                  bubbles: true
                }));
              });
    
              returnCartEvent()
            }, 400); 
    
            return response.json();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          return;
        });
      }, 400)
    }
    
    // Remove from cart function
    function removeItemFromCart(item) {
      let data = {
        'updates': {
          [item.key]: item.quantity - 1
        }
      };
    
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        //Refresh cart
        if(response) {
          setTimeout(function() {
            jQuery.getJSON('/cart.js', function(cart) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            });
          }, 400);
    
          return response.json();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        return;
      });
    }
  }
  
})();


/** Hide Embroidery */
$( document ).ready(function() {
  setTimeout(function(){
    let embroidery_input_initial = document.querySelector(".cl-po--input")

    if(embroidery_input_initial ){
      document.querySelector(".ProductForm__BuyButtonsWrapper .inject").style.display = "block"
      document.querySelector(".EmbroideryPrice").style.display = "block"
      document.querySelector(".EmbroideryText").style.opacity = "1"
      
      if(embroidery_input_initial.checked === true){
        document.querySelector(".CustomizerPreviewAnchor").style.display = "block"
      }
    } else {
      document.querySelector(".CustomizerPreviewAnchor").style.display = "none"
      document.querySelector(".ProductForm__BuyButtonsWrapper .inject").style.display = "none"
      document.querySelector(".EmbroideryPrice").style.display = "none"
      document.querySelector(".EmbroideryText").style.opacity = "0"
    }
  }, 1000)
});

document.addEventListener('variant:changed', function(event) {
  setTimeout(function(){
    let embroidery_input = document.querySelector(".cl-po--input")

    if(embroidery_input){
      document.querySelector(".inject.ProductForm__Embroidery").style.display = "block"
      document.querySelector(".EmbroideryPrice").style.display = "block"
      document.querySelector(".EmbroideryText").style.opacity = "1"

      if(embroidery_input.checked === true){
        document.querySelector(".CustomizerPreviewAnchor").style.display = "block"
      }

    } else {
      document.querySelector(".CustomizerPreviewAnchor").style.display = "none"
      document.querySelector(".inject.ProductForm__Embroidery").style.display = "none"
      document.querySelector(".EmbroideryPrice").style.display = "none"
      document.querySelector(".EmbroideryText").style.opacity = "0"
    }
  }, 1000)
});

